import { render } from "./riskAcceptance.vue?vue&type=template&id=26a721e2&scoped=true&ts=true"
import script from "./riskAcceptance.vue?vue&type=script&lang=ts"
export * from "./riskAcceptance.vue?vue&type=script&lang=ts"

import "./riskAcceptance.vue?vue&type=style&index=0&id=26a721e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a721e2"]])

export default __exports__